import { DIRECTION_DOWN, DIRECTION_LEFT, DIRECTION_RIGHT, DIRECTION_UP } from '../contants';
/**
 * 입력 된 방향의 반대 방향을 반환합니다. 입력된 방향의 대해 해당되는 케이스가 없는 경우 입력된 방향 그대로 반환합니다.
 * @param direction
 */
var getOppositeDirection = function (direction) {
    var oppositeDirection = direction;
    switch (direction) {
        case DIRECTION_UP:
            oppositeDirection = DIRECTION_DOWN;
            break;
        case DIRECTION_DOWN:
            oppositeDirection = DIRECTION_UP;
            break;
        case DIRECTION_LEFT:
            oppositeDirection = DIRECTION_RIGHT;
            break;
        case DIRECTION_RIGHT:
            oppositeDirection = DIRECTION_LEFT;
            break;
        default:
            break;
    }
    return oppositeDirection;
};
export default getOppositeDirection;
